import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function CallEmployeeButton({ 
  employeeName, 
  employeePhone, 
  showSMS = false,
  className = "",
  buttonSize = "md"
}) {
  // Handle phone call
  const handleCall = () => {
    if (!employeePhone) {
      alert("Employee phone number not available");
      return;
    }
    
    // Remove any non-numeric characters
    const cleanPhone = employeePhone.replace(/\D/g, "");
    
    // Create tel: link - works on mobile, opens dialer on desktop
    window.location.href = `tel:${cleanPhone}`;
  };

  // Handle SMS (optional)
  const handleSMS = () => {
    if (!employeePhone) {
      alert("Employee phone number not available");
      return;
    }
    
    const cleanPhone = employeePhone.replace(/\D/g, "");
    window.location.href = `sms:${cleanPhone}`;
  };

  const sizeClasses = {
    sm: "py-2 px-3 text-sm",
    md: "py-3 px-4 text-base",
    lg: "py-4 px-6 text-lg"
  };

  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      {/* Call Button */}
      <button
        onClick={handleCall}
        disabled={!employeePhone}
        className={`flex-1 flex items-center justify-center gap-2 ${
          employeePhone 
            ? "bg-green-500 hover:bg-green-600 text-white" 
            : "bg-gray-500 text-white/70"
        } disabled:cursor-not-allowed font-bold rounded-xl sm:rounded-2xl shadow-lg transition transform hover:scale-105 active:scale-95 ${sizeClasses[buttonSize]}`}
        title={employeePhone ? `Call ${employeeName}` : "Loading phone number..."}
      >
        <Phone size={20} className="sm:size-6" />
        <span className="hidden sm:inline">Call {employeeName}</span>
        <span className="sm:hidden">Call</span>
      </button>

      {/* SMS Button (optional) */}
      {showSMS && (
        <button
          onClick={handleSMS}
          disabled={!employeePhone}
          className={`flex-1 sm:flex-none flex items-center justify-center gap-2 ${
            employeePhone 
              ? "bg-blue-500 hover:bg-blue-600 text-white" 
              : "bg-gray-500 text-white/70"
          } disabled:cursor-not-allowed font-bold rounded-xl sm:rounded-2xl shadow-lg transition transform hover:scale-105 active:scale-95 ${sizeClasses[buttonSize]}`}
          title={employeePhone ? `Send SMS to ${employeeName}` : "Loading phone number..."}
        >
          <MessageCircle size={20} className="sm:size-6" />
          <span className="hidden sm:inline">SMS</span>
        </button>
      )}
    </div>
  );
}
